'use strict';

var $    = require('jquery');
var _    = require('underscore');
var Core = require('../core/core.js');

/**
 * Creates an inspector with value and unit
 *
 * @class
 */

class InspectorSlider extends Core {

	_defaults() {
		return {
			target: '.js-editor',
			fields: {
				'title': '',
				'value': '',
				'min': 1,
				'max': 100,
				'step': 1,
				'tooltip': ''
			}
		};
	}

	constructor(options) {
		super(options);

		this.template = `
			<div class="editor__inspector__item">
				<div class="editor__inspector__item__label__singleline" title="<%- tooltip %>"><%- title %></div>
				<input class="editor__inspector__item__textinput editor__inspector__item__textinput--slider js-inspector__textinput__value" type="text" value="<%- value %>">
				<div class="editor__inspector__item__slidershell js-inspector__slider__container">
					<div class="editor__inspector__item__slidershell__track js-inspector__slider__track"></div>
					<div class="editor__inspector__item__slidershell__fill js-inspector__slider__fill"></div>
					<div class="editor__inspector__item__slidershell__thumb js-inspector__slider__thumb"></div>
					<input class="editor__inspector__item__slidershell__slider js-inspector__slider" type="range" min="<%- min %>" max="<%- max %>" step="<%- step %>" value="<%- value %>" />
				</div>
			</div>
		`;

		super.render();

		/**
		* Text input
		*
		* @fires InspectorSlider#_valuechanged
		*/

		$('.js-inspector__textinput__value', this.$el).on('change', this._valuechanged);
		$('.js-inspector__textinput__value', this.$el).on('focus', this._focus);
		$('.js-inspector__textinput__value', this.$el).on('blur', this._blur);

		var self = this;
		$('.js-inspector__textinput__value', this.$el).keypress(function(e) {
		   if (e.which == 13) {
		   	self._enter(e);
		   }
		});

		/**
		* Slider
		*
		* @fires InspectorSlider#_valuechanged
		*/

		$('.js-inspector__slider', this.$el).on('input', this._valuechanged);
		$('.js-inspector__slider', this.$el).on('input', this._setSliderValue);
		this.setValue(options.fields.value);

		$('.js-inspector__slider', this.$el).on('mousedown', function(e) {
			$(this).siblings('.js-inspector__slider__thumb').addClass('editor__inspector__item__slidershell__thumb--active');
			$(e.currentTarget).trigger('Cioui:Inspector:beginChange', $(e.currentTarget).val());
		}).on('mouseup', function(e) {
			$(this).siblings('.js-inspector__slider__thumb').removeClass('editor__inspector__item__slidershell__thumb--active');
			$(e.currentTarget).trigger('Cioui:Inspector:endChange', $(e.currentTarget).val());
		});

	}

	/**
		* @event InspectorValueUnit#Cioui:Inspector:value
		* @property {String}Cioui:Inspector:value
		* @returns {String} value - the new text input obj
		*/

	_valuechanged(e){
		if($(e.currentTarget).hasClass('js-inspector__textinput__value')) {
			var $slider =  $(e.currentTarget).siblings('.js-inspector__slider__container').children('.js-inspector__slider');
			$slider.val($(e.currentTarget).val());
			$slider.trigger('input');
		} else {
			$(e.currentTarget).trigger('Cioui:Inspector:value', $(e.currentTarget).val());
		}
	}

	/**
		* @event InspectorValueUnit#Cioui:Inspector:focus
		* @property {String}Cioui:Inspector:focus
		* @returns {String} value - the new text input obj
		*/
	_focus(e){
		$(e.currentTarget).trigger('Cioui:Inspector:focus', $(e.currentTarget).val());
	}

	/**
		* @event InspectorValueUnit#Cioui:Inspector:blur
		* @property {String}Cioui:Inspector:blur
		* @returns {String} value - the new text input obj
		*/
	_blur(e){
		$(e.currentTarget).trigger('Cioui:Inspector:blur', $(e.currentTarget).val());
	}

	/**
     * @event InspectorValueUnit#Cioui:Inspector:enter
     * @property {String}Cioui:Inspector:enter
     * @returns {String} value - the new text input obj
     */
	_enter(e){
		$(e.currentTarget).trigger('Cioui:Inspector:enter', $(e.currentTarget).val());
	}

	/**
	* setValue
	*
	* @param {string} value - the value that you want to set
	*/

	setValue(value){
		$('.js-inspector__textinput__value', this.$el).val(value);
		$('.js-inspector__slider', this.$el).val(value);
		$('.js-inspector__slider', this.$el).trigger('input');
	}

	_setSliderValue(e) {
		var $slider =  $(e.currentTarget);
		var $thumb = $(e.currentTarget).siblings('.js-inspector__slider__thumb');
		var $shell = $(e.currentTarget).parent();
		var $track = $(e.currentTarget).siblings('.js-inspector__slider__track');
		var $fill = $(e.currentTarget).siblings('.js-inspector__slider__fill');
		var $value = $shell.siblings('input');
		$value.val($slider.val());

		var pc = ($slider.val()-$slider.prop("min"))/($slider.prop("max") - $slider.prop("min"));
		var thumbSize = 15;
		var bigval = $shell.parent().width();
		var smallval = 15;

		var tracksize = bigval - thumbSize;
		var fillsize = 2;
		var filloffset = smallval/2;
		var bordersize = 0;
		var loc = pc * tracksize;

		$fill.css({
			'top': (filloffset + bordersize) + "px",
			'left': '0px',
			'width': (loc + thumbSize/2) + "px",
			'height': fillsize + "px",
		});
		$thumb.css({
			'top': filloffset/2+'px',
			'left': loc+'px'
		});
		$shell.css({
			'height': smallval + "px",
			'width': bigval + "px"
		});
		$track.css({
			'height': fillsize + "px",
			'width': (bigval-4) + "px",
			'left': '0px',
			'top': (filloffset + bordersize) + "px"
		});

	}

}
module.exports = InspectorSlider;
